import axiosInstance from '../app/axios';
import ServiceTierDTO from '../shared/dtos/serviceTierDTO';
import ServiceTypeDTO from '../shared/dtos/serviceTypeDTO';

interface PaginatedProps {
  page?: number;
  take?: number;
  search?: string;
  scope?: 'all' | 'global' | 'admin';
  adminId?: number;
}

interface AvailableServiceTypesProps {
  scope: 'global' | 'admin';
  adminId?: number;
  excludedTierId?: number;
}

export const getServiceTierPaginatedList = async ({
  page = 1,
  take = 10,
  search = '',
  scope = 'all',
  adminId,
}: PaginatedProps) => {
  const params = new URLSearchParams();
  params.append('page', String(page));
  params.append('take', String(take));
  params.append('scope', scope);

  if (search) {
    params.append('search', search);
  }

  if (adminId) {
    params.append('adminId', String(adminId));
  }

  const result = await axiosInstance.get(`service-tiers?${params.toString()}`, {
    headers: { 'x-hide-success': true },
  });

  return result.data;
};

export const getServiceTier = async (id: number) => {
  const result = await axiosInstance.get(`service-tiers/${id}`, {
    headers: { 'x-hide-success': true },
  });

  return result.data as ServiceTierDTO;
};

export const createServiceTier = async (serviceTierDTO: ServiceTierDTO) => {
  const result = await axiosInstance.post('service-tiers', serviceTierDTO);
  return result.data as ServiceTierDTO;
};

export const patchServiceTier = async (id: number, serviceTierDTO: Partial<ServiceTierDTO>) => {
  const result = await axiosInstance.patch(`service-tiers/${id}`, serviceTierDTO);
  return result.data;
};

export const deleteServiceTier = async (id: number) => {
  const result = await axiosInstance.delete(`service-tiers/${id}`);
  return result.data;
};

export const getAvailableServiceTypesForTier = async ({
  scope,
  adminId,
  excludedTierId,
}: AvailableServiceTypesProps) => {
  const params = new URLSearchParams();
  params.append('scope', scope);

  if (adminId) {
    params.append('adminId', String(adminId));
  }

  if (excludedTierId) {
    params.append('excludedTierId', String(excludedTierId));
  }

  const result = await axiosInstance.get(
    `service-tiers/available-service-types?${params.toString()}`,
    {
      headers: { 'x-hide-success': true },
    },
  );

  return (result.data || []) as ServiceTypeDTO[];
};

export const reorderServiceTiers = async (
  items: { id: number; sortOrder: number }[],
) => {
  const result = await axiosInstance.post("service-tiers/reorder", items);
  return result.data;
};
